import type { ReceiptDraftContentType } from '@splitfiesta/shared';

export type ReceiptFileKind = 'image' | 'pdf';

export function fileKindOf(
  contentType: ReceiptDraftContentType
): ReceiptFileKind {
  return contentType === 'application/pdf' ? 'pdf' : 'image';
}

/** A stored receipt's kind; the query string is ignored. */
export function isPdfReceiptUrl(url: string): boolean {
  return /\.pdf$/i.test(url.split(/[?#]/, 1)[0]);
}
